import { initHoverLinks } from '../../pages/constuctor';

let linksInit = false;

window.dispatchEvent(new Event('preloaded'));

/**
 * Выполняем функцию initHoverLinks после прелоадера,
 * потому что из-за неё фризы в анимации
 */

setTimeout(() => {
    document.getElementsByTagName('html')[0].classList.add('_is-preloaded');

    // Если прелоадер не показывается
    if (window.sessionStorage.preloaderAnimated && !linksInit) {
        initHoverLinks();
        linksInit = true;
    }
}, 100);

window.addEventListener('preloaderCompleted', () => {
    // После прелоадера, если он показывается
    if (!linksInit) {
        initHoverLinks();
        linksInit = true;
    }
});

setTimeout(() => {
    // На всякий случай по таймауту, если что-то не сработало
    if (!linksInit) {
        initHoverLinks();
        linksInit = true;
    }
}, 10000);
